import React from 'react';
import { Target, Trophy, Shield } from 'lucide-react';

const WhyChooseUs = () => {
  const coreValues = [
    {
      icon: Target,
      label: 'Our Purpose',
      sublabel: 'To enable every family build a lasting legacy'
    },
    {
      icon: Trophy,
      label: 'Our Mission',
      sublabel: 'Provide unbiased investing aided by tech powered research'
    },
    {
      icon: Shield,
      label: 'Our Values',
      sublabel: 'Client first, Utmost transparency and Integrity'
    }
  ];

  return (
    <div className="relative bg-gradient-to-br from-[#113262] to-[#113262] isolate min-h-[75vh] flex items-center">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 lg:pt-36">
        {/* Introduction Text */}
        <div className="max-w-3xl mx-auto mb-8">
          <p className="text-lg md:text-xl text-white/90 leading-relaxed text-center">
            We started Maxiom with a simple idea: wealth management should be transparent, 
            accessible, and built on research-backed principles. 
          </p>
        </div>

        {/* Core Values - Column Layout */}
        <div className="flex flex-col space-y-4 max-w-xl mx-auto">
          {coreValues.map((value, index) => (
            <div 
              key={index}
              className="bg-white/10 rounded-xl border border-white/20 p-4 transition-all duration-300 hover:border-[#F49611]"
            >
              <div className="flex items-center gap-4">
                <div className={`p-2 sm:p-3 bg-gradient-to-br ${index === 1 ? 'from-[#F49611] to-[#955C0A]' : 'from-[#1C52A0] to-[#0A1E3A]'} rounded-lg`}>
                  <value.icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">{value.label}</h3>
                  <p className="text-white/80">{value.sublabel}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;